import React from 'react';

import { Link } from 'react-router-dom';

import { arrowLeft } from 'assets';

interface IBackBtnProps {
  to?: string;
  text: string;
  onClick?: any;
}

const BackBtn = ({ to, onClick, text }: IBackBtnProps) => {
  if (to) {
    return (
      <Link to={to} className="d-flex mt-4 mb-4">
        <img src={arrowLeft} /> <h5 className="m-0 ms-2 text-capitalize">{text}</h5>
      </Link>
    );
  }
  return (
    <div onClick={onClick} className="d-flex mt-4 mb-4 cursor-pointer" data-test="back-btn">
      <img src={arrowLeft} /> <h5 className="m-0 ms-2 text-capitalize">{text}</h5>
    </div>
  );
};

export default BackBtn;
